"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceColumn = exports.BimLocationsColumn = exports.NumberColumn = exports.MultiSelectColumn = exports.BooleanColumn = exports.ControlCostRowColumn = exports.MeasurementColumn = exports.CheckboxesColumn = exports.CausalityColumn = exports.LinksColumn = exports.EvaluationColumn = exports.DateTimeColumn = exports.DateColumn = exports.AutoSuggestColumn = exports.ButtonGroupColumn = exports.SelectColumn = exports.UserColumn = exports.FileColumn = exports.TextColumn = exports.IdColumn = exports.RowSelectorColumn = exports.Column = exports.dispatchColumn = exports.ObservationsColumnIds = exports.GameNoticesColumnIds = exports.ProjectFilesColumnIds = exports.PLayersColumnIds = exports.OverviewTablesColumnIds = exports.CausalityColumnIds = exports.ActionColumnIds = exports.ControlColumnIds = exports.RiskColumnIds = exports.ColumnTypes = void 0;
var ColumnTypes = (function () {
    function ColumnTypes() {
    }
    ColumnTypes.ROW_SELECTOR = 'selector';
    ColumnTypes.ID = 'id';
    ColumnTypes.TEXT = 'text';
    ColumnTypes.USER = 'user';
    ColumnTypes.SELECT = 'select';
    ColumnTypes.AUTOSUGGEST = 'autosuggest';
    ColumnTypes.DATE = 'date';
    ColumnTypes.DATETIME = 'datetime';
    ColumnTypes.EVALUATION = 'evaluation';
    ColumnTypes.LINKS = 'links';
    ColumnTypes.CAUSALITY = 'causality';
    ColumnTypes.CHECKBOXES = 'checkboxes';
    ColumnTypes.MEASUREMENT = 'measurement';
    ColumnTypes.CONTROLCOSTROW = 'controlcost_row';
    ColumnTypes.BOOLEAN = 'boolean';
    ColumnTypes.MULTISELECT = 'multiselect';
    ColumnTypes.NUMBER = 'number';
    ColumnTypes.REFERENCE = "reference";
    ColumnTypes.FILE = "file";
    ColumnTypes.PASSWORD = "password";
    ColumnTypes.BUTTON_GROUP = "button_group";
    ColumnTypes.BIM_LOCATIONS = "bim_locations";
    return ColumnTypes;
}());
exports.ColumnTypes = ColumnTypes;
var RiskColumnIds = (function () {
    function RiskColumnIds() {
    }
    RiskColumnIds.RISK_NUMBER = "risk_number";
    RiskColumnIds.TITLE = "title";
    RiskColumnIds.CAUSE = "_cause_description";
    RiskColumnIds.DESCRIPTION = "risk_description";
    RiskColumnIds.EFFECT = "_effect_description";
    RiskColumnIds.NOTES = "notes_description";
    RiskColumnIds.REFERENCES = "risk_references";
    RiskColumnIds.OWNER = "owner";
    RiskColumnIds.STATUS = "status";
    RiskColumnIds.LAST_MODIFIED = "modified";
    RiskColumnIds.CONFIDENTIAL = "groups";
    RiskColumnIds.WORST_RISK = "worst_risk";
    RiskColumnIds.BEST_RISK = "best_risk";
    RiskColumnIds.EVALUATION = "_evaluations";
    RiskColumnIds.CATEGORY = "tags";
    RiskColumnIds.REVIEWED_BY = "reviewed_by";
    RiskColumnIds.REVIEWED_AT = "reviewed_at";
    RiskColumnIds.CONTROLS = "_control_relations";
    RiskColumnIds.REMOVE_CONTROLS = "_remove_control_relations";
    RiskColumnIds.USERDEFINED = "userdefined";
    RiskColumnIds.BIM_LOCATIONS = "bim_locations";
    return RiskColumnIds;
}());
exports.RiskColumnIds = RiskColumnIds;
var ControlColumnIds = (function () {
    function ControlColumnIds() {
    }
    ControlColumnIds.CONTROL_NUMBER = "control_number";
    ControlColumnIds.TITLE = "description";
    ControlColumnIds.OWNER = "assigned_to";
    ControlColumnIds.STATUS = "status";
    ControlColumnIds.DEADLINE = "deadline";
    ControlColumnIds.LAST_MODIFIED = "modified";
    ControlColumnIds.CATEGORY = "tags";
    ControlColumnIds.RISK_RELATIONS = "_risk_relations";
    ControlColumnIds.REMOVE_RISK_RELATIONS = "_remove_risk_relations";
    ControlColumnIds.CONTROL_COST = "control_cost";
    ControlColumnIds.USERDEFINED = "userdefined";
    ControlColumnIds.CONFIDENTIAL = "control_confidentiality";
    ControlColumnIds.REFERENCES = "control_references";
    ControlColumnIds.BIM_LOCATIONS = "bim_locations";
    return ControlColumnIds;
}());
exports.ControlColumnIds = ControlColumnIds;
var ActionColumnIds = (function () {
    function ActionColumnIds() {
    }
    ActionColumnIds.ACTION_NUMBER = "action_number";
    ActionColumnIds.TITLE = "description";
    ActionColumnIds.OWNER = "assigned_to";
    ActionColumnIds.STATUS = "status";
    ActionColumnIds.DEADLINE = "deadline";
    ActionColumnIds.LAST_MODIFIED = "modified";
    ActionColumnIds.CATEGORY = "tags";
    ActionColumnIds.CONFIDENTIAL = "action_confidentiality";
    ActionColumnIds.REFERENCES = "action_references";
    return ActionColumnIds;
}());
exports.ActionColumnIds = ActionColumnIds;
var CausalityColumnIds = (function () {
    function CausalityColumnIds() {
    }
    CausalityColumnIds.NUMBER = "number";
    CausalityColumnIds.TEXT = "text";
    CausalityColumnIds.RISK_RELATIONS = "_risk_relations";
    CausalityColumnIds.REMOVE_RISK_RELATIONS = "_remove_risk_relations";
    CausalityColumnIds.CONFIDENTIAL = "causality_confidentiality";
    return CausalityColumnIds;
}());
exports.CausalityColumnIds = CausalityColumnIds;
var OverviewTablesColumnIds = (function () {
    function OverviewTablesColumnIds() {
    }
    OverviewTablesColumnIds.RISK_OWNER = "owner_fullname";
    OverviewTablesColumnIds.CONTROL_OWNER = "assigned_to_fullname";
    OverviewTablesColumnIds.ACTION_OWNER = "assigned_to_fullname";
    OverviewTablesColumnIds.STATUS_DISPLAY = "status_display";
    OverviewTablesColumnIds.EVALUATION_OWNER = "risk_owner_name";
    OverviewTablesColumnIds.EVALUATION_TITLE = "risk_title";
    OverviewTablesColumnIds.EVALUATION_STATUS = "risk_status";
    return OverviewTablesColumnIds;
}());
exports.OverviewTablesColumnIds = OverviewTablesColumnIds;
var PLayersColumnIds = (function () {
    function PLayersColumnIds() {
    }
    PLayersColumnIds.ID = "id";
    PLayersColumnIds.COMPANY = "company";
    PLayersColumnIds.NAME = "name";
    PLayersColumnIds.TELEPHONE = "telephone";
    PLayersColumnIds.GAME_STATUS = "game_status";
    PLayersColumnIds.GAME_SCORE = "game_score";
    PLayersColumnIds.GAME_RESULT = "game_result";
    PLayersColumnIds.ENABLED = "is_active";
    PLayersColumnIds.INACTIVITY = 'inactivity';
    return PLayersColumnIds;
}());
exports.PLayersColumnIds = PLayersColumnIds;
var ProjectFilesColumnIds = (function () {
    function ProjectFilesColumnIds() {
    }
    ProjectFilesColumnIds.ID = "id";
    ProjectFilesColumnIds.ASSET_STATUS = "asset_status";
    ProjectFilesColumnIds.ASSET_CLASSIFICATION = "classification";
    ProjectFilesColumnIds.CONTENT = "content";
    return ProjectFilesColumnIds;
}());
exports.ProjectFilesColumnIds = ProjectFilesColumnIds;
var GameNoticesColumnIds = (function () {
    function GameNoticesColumnIds() {
    }
    GameNoticesColumnIds.ID = "id";
    GameNoticesColumnIds.TITLE = "title";
    GameNoticesColumnIds.CONTENT = "content";
    GameNoticesColumnIds.LAST_MODIFIED = "last_modified";
    GameNoticesColumnIds.ENABLED = "active";
    return GameNoticesColumnIds;
}());
exports.GameNoticesColumnIds = GameNoticesColumnIds;
var ObservationsColumnIds = (function () {
    function ObservationsColumnIds() {
    }
    ObservationsColumnIds.ID = "id";
    ObservationsColumnIds.PHONE = "telephone";
    ObservationsColumnIds.COMPANY = "company";
    ObservationsColumnIds.DATE = "date";
    ObservationsColumnIds.OBS = "observation_data";
    ObservationsColumnIds.STATUS = "status";
    return ObservationsColumnIds;
}());
exports.ObservationsColumnIds = ObservationsColumnIds;
function dispatchColumn(column) {
    switch (column.type) {
        case ColumnTypes.ID:
            return new IdColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.TEXT:
            return new TextColumn(column.id, column.show_url, column.editable, column.field_object_id);
        case ColumnTypes.FILE:
            return new FileColumn(column.id, column.show_url, column.editable, column.field_object_id);
        case ColumnTypes.USER:
            return new UserColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.SELECT:
            return new SelectColumn(column.id, column.show_url, column.editable, column.options, column.field_object_id);
        case ColumnTypes.BUTTON_GROUP:
            return new ButtonGroupColumn(column.id, column.show_url, column.editable, column.options, column.field_object_id);
        case ColumnTypes.AUTOSUGGEST:
            return new AutoSuggestColumn(column.id, column.show_url, column.editable, column.options, column.field_object_id);
        case ColumnTypes.DATE:
            return new DateColumn(column.id, column.show_url, column.editable, column.field_object_id);
        case ColumnTypes.DATETIME:
            return new DateTimeColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.EVALUATION:
            return new EvaluationColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.LINKS:
            return new LinksColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.CAUSALITY:
            return new CausalityColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.CHECKBOXES:
            return new CheckboxesColumn(column.id, column.show_url, column.editable, column.options);
        case ColumnTypes.MEASUREMENT:
            return new MeasurementColumn(column.id, column.show_url, column.editable, column.options, column.field_object_id);
        case ColumnTypes.CONTROLCOSTROW:
            return new ControlCostRowColumn(column.id, column.show_url, column.editable, column.options);
        case ColumnTypes.BOOLEAN:
            return new BooleanColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.MULTISELECT:
            return new MultiSelectColumn(column.id, column.show_url, column.editable, column.options, column.field_object_id);
        case ColumnTypes.NUMBER:
            return new NumberColumn(column.id, column.show_url, column.editable, column.field_object_id);
        case ColumnTypes.REFERENCE:
            return new ReferenceColumn(column.id, column.show_url, column.editable);
        case ColumnTypes.BIM_LOCATIONS:
            return new BimLocationsColumn(column.id, column.show_url, column.editable);
        default:
            console.error("Error: Unknown or missing column.type", column.type);
            console.log(column);
            throw new Error("Unknown or missing column type: " + column.type.toString());
    }
}
exports.dispatchColumn = dispatchColumn;
var Column = (function () {
    function Column(id, show_url, editable, options, field_object_id) {
        if (options === void 0) { options = []; }
        this.HeaderClass = [];
        this.FieldClass = [];
        this.id = id;
        this.show_url = show_url;
        this.editable = editable;
        this.options = options;
        this.field_object_id = field_object_id;
        this.HeaderClass.push('EditableList__Header');
        this.FieldClass.push('EditableList__Field');
    }
    Column.prototype.get_header_class = function () {
        return this.HeaderClass.join(" ");
    };
    Column.prototype.get_field_class = function () {
        return this.FieldClass.join(" ");
    };
    Column.prototype.get_options = function () {
        return this.options || [];
    };
    return Column;
}());
exports.Column = Column;
var RowSelectorColumn = (function (_super) {
    __extends(RowSelectorColumn, _super);
    function RowSelectorColumn() {
        var _this = _super.call(this, ColumnTypes.ROW_SELECTOR, false, false) || this;
        _this.HeaderClass.push('EditableList__Header--Selector');
        _this.FieldClass.push('EditableList__Field--Selector');
        return _this;
    }
    return RowSelectorColumn;
}(Column));
exports.RowSelectorColumn = RowSelectorColumn;
var IdColumn = (function (_super) {
    __extends(IdColumn, _super);
    function IdColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Id');
        _this.FieldClass.push('EditableList__Field--Id');
        return _this;
    }
    return IdColumn;
}(Column));
exports.IdColumn = IdColumn;
var TextColumn = (function (_super) {
    __extends(TextColumn, _super);
    function TextColumn(id, show_url, editable, field_object_id) {
        var _this = _super.call(this, id, show_url, editable, null, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Text');
        _this.FieldClass.push('EditableList__Field--Text');
        return _this;
    }
    return TextColumn;
}(Column));
exports.TextColumn = TextColumn;
var FileColumn = (function (_super) {
    __extends(FileColumn, _super);
    function FileColumn(id, show_url, editable, field_object_id) {
        var _this = _super.call(this, id, show_url, editable, null, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Text');
        _this.FieldClass.push('EditableList__Field--Text');
        return _this;
    }
    return FileColumn;
}(Column));
exports.FileColumn = FileColumn;
var UserColumn = (function (_super) {
    __extends(UserColumn, _super);
    function UserColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--User');
        _this.FieldClass.push('EditableList__Field--User');
        return _this;
    }
    return UserColumn;
}(Column));
exports.UserColumn = UserColumn;
var SelectColumn = (function (_super) {
    __extends(SelectColumn, _super);
    function SelectColumn(id, show_url, editable, options, field_object_id) {
        if (options === void 0) { options = []; }
        var _this = _super.call(this, id, show_url, editable, options, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Select');
        _this.FieldClass.push('EditableList__Field--Select');
        return _this;
    }
    return SelectColumn;
}(Column));
exports.SelectColumn = SelectColumn;
var ButtonGroupColumn = (function (_super) {
    __extends(ButtonGroupColumn, _super);
    function ButtonGroupColumn(id, show_url, editable, options, field_object_id) {
        if (options === void 0) { options = []; }
        return _super.call(this, id, show_url, editable, options, field_object_id) || this;
    }
    return ButtonGroupColumn;
}(Column));
exports.ButtonGroupColumn = ButtonGroupColumn;
var AutoSuggestColumn = (function (_super) {
    __extends(AutoSuggestColumn, _super);
    function AutoSuggestColumn(id, show_url, editable, options, field_object_id) {
        if (options === void 0) { options = []; }
        var _this = _super.call(this, id, show_url, editable, options, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Select');
        _this.FieldClass.push('EditableList__Field--Select');
        return _this;
    }
    return AutoSuggestColumn;
}(Column));
exports.AutoSuggestColumn = AutoSuggestColumn;
var DateColumn = (function (_super) {
    __extends(DateColumn, _super);
    function DateColumn(id, show_url, editable, field_object_id) {
        var _this = _super.call(this, id, show_url, editable, null, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Date');
        _this.FieldClass.push('EditableList__Field--Date');
        return _this;
    }
    return DateColumn;
}(Column));
exports.DateColumn = DateColumn;
var DateTimeColumn = (function (_super) {
    __extends(DateTimeColumn, _super);
    function DateTimeColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Datetime');
        _this.FieldClass.push('EditableList__Field--Datetime');
        return _this;
    }
    return DateTimeColumn;
}(Column));
exports.DateTimeColumn = DateTimeColumn;
var EvaluationColumn = (function (_super) {
    __extends(EvaluationColumn, _super);
    function EvaluationColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Evaluation');
        _this.FieldClass.push('EditableList__Field--Evaluation');
        return _this;
    }
    return EvaluationColumn;
}(Column));
exports.EvaluationColumn = EvaluationColumn;
var LinksColumn = (function (_super) {
    __extends(LinksColumn, _super);
    function LinksColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Links');
        _this.FieldClass.push('EditableList__Field--Links');
        return _this;
    }
    return LinksColumn;
}(Column));
exports.LinksColumn = LinksColumn;
var CausalityColumn = (function (_super) {
    __extends(CausalityColumn, _super);
    function CausalityColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Causality');
        _this.FieldClass.push('EditableList__Field--Causality');
        return _this;
    }
    return CausalityColumn;
}(Column));
exports.CausalityColumn = CausalityColumn;
var CheckboxesColumn = (function (_super) {
    __extends(CheckboxesColumn, _super);
    function CheckboxesColumn(id, show_url, editable, options) {
        if (options === void 0) { options = []; }
        var _this = _super.call(this, id, show_url, editable, options) || this;
        _this.HeaderClass.push('EditableList__Header--Checkboxes');
        _this.FieldClass.push('EditableList__Field--Checkboxes');
        return _this;
    }
    return CheckboxesColumn;
}(Column));
exports.CheckboxesColumn = CheckboxesColumn;
var MeasurementColumn = (function (_super) {
    __extends(MeasurementColumn, _super);
    function MeasurementColumn(id, show_url, editable, options, field_object_id) {
        if (options === void 0) { options = []; }
        var _this = _super.call(this, id, show_url, editable, options, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Measurement');
        _this.FieldClass.push('EditableList__Field--Measurement');
        return _this;
    }
    return MeasurementColumn;
}(Column));
exports.MeasurementColumn = MeasurementColumn;
var ControlCostRowColumn = (function (_super) {
    __extends(ControlCostRowColumn, _super);
    function ControlCostRowColumn(id, show_url, editable, options) {
        if (options === void 0) { options = []; }
        return _super.call(this, id, show_url, editable, options) || this;
    }
    return ControlCostRowColumn;
}(Column));
exports.ControlCostRowColumn = ControlCostRowColumn;
var BooleanColumn = (function (_super) {
    __extends(BooleanColumn, _super);
    function BooleanColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Boolean');
        _this.FieldClass.push('EditableList__Field--Boolean');
        return _this;
    }
    return BooleanColumn;
}(Column));
exports.BooleanColumn = BooleanColumn;
var MultiSelectColumn = (function (_super) {
    __extends(MultiSelectColumn, _super);
    function MultiSelectColumn(id, show_url, editable, options, field_object_id) {
        if (options === void 0) { options = []; }
        var _this = _super.call(this, id, show_url, editable, options, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Select');
        _this.FieldClass.push('EditableList__Field--Select');
        return _this;
    }
    return MultiSelectColumn;
}(Column));
exports.MultiSelectColumn = MultiSelectColumn;
var NumberColumn = (function (_super) {
    __extends(NumberColumn, _super);
    function NumberColumn(id, show_url, editable, field_object_id) {
        var _this = _super.call(this, id, show_url, editable, null, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--Text');
        _this.FieldClass.push('EditableList__Field--Text');
        return _this;
    }
    return NumberColumn;
}(Column));
exports.NumberColumn = NumberColumn;
var BimLocationsColumn = (function (_super) {
    __extends(BimLocationsColumn, _super);
    function BimLocationsColumn(id, show_url, editable, field_object_id) {
        var _this = _super.call(this, id, show_url, editable, null, field_object_id) || this;
        _this.HeaderClass.push('EditableList__Header--BIMLocations');
        _this.FieldClass.push('EditableList__Field--BIMLocations');
        return _this;
    }
    return BimLocationsColumn;
}(Column));
exports.BimLocationsColumn = BimLocationsColumn;
var ReferenceColumn = (function (_super) {
    __extends(ReferenceColumn, _super);
    function ReferenceColumn(id, show_url, editable) {
        var _this = _super.call(this, id, show_url, editable) || this;
        _this.HeaderClass.push('EditableList__Header--Reference');
        _this.FieldClass.push('EditableList__Field--Reference');
        return _this;
    }
    return ReferenceColumn;
}(Column));
exports.ReferenceColumn = ReferenceColumn;
